import { IbhEventCategory } from '@hub/bearing-hub/common/tracking.config';
import type { trackingApps } from '@hub/libs/tracking/config';
import { ffhEventCategory } from '@hub/free-form-hub/tracking.config';

export type TrackingApps = (typeof trackingApps)[keyof typeof trackingApps];

type EventCategory = typeof IbhEventCategory | typeof ffhEventCategory;

type TrackingEventCategoryDefinition = {
  [key in TrackingApps]: EventCategory;
};

const trackingEventCategoryDefinition: TrackingEventCategoryDefinition = {
  ibh: IbhEventCategory,
  ffh: ffhEventCategory,
};

export const getEventCategory = (path: string): EventCategory | undefined => {
  if (path.startsWith('/iglidur-ibh/') || path.startsWith('/iglide-ibh/')) {
    return trackingEventCategoryDefinition.ibh;
  }

  if (path.startsWith('/free-form-hub')) {
    return trackingEventCategoryDefinition.ffh;
  }
  return undefined;
};
